import { request, Response } from '../utils';
import { V1GraphForStorage, Session } from '../types';

export const readGraph = (body: {
  session?: Session;
  graphID: string;
}): Response<V1GraphForStorage> => request('read-graph', body);
